import React from 'react';
import ResolveManually from "../features/emails-for-review/pages/resolve-manually/ResolveManually";
import { Stack } from "@chakra-ui/react";

const ResolveManuallyPage = () => {
  return (
    <Stack gap={5}>
      <ResolveManually />
    </Stack>
  );
};
export default ResolveManuallyPage;
